import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const reviewCount = 10;

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/charting/conditions'],
  validationMode: 'count',
  requiredCount: reviewCount,
};

export const conditionsSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.ConditionsSetup,
  category: PracticeSetupStepCategory.ConditionsAndTreatments,
  title: 'Review and Configure Conditions',
  description: initRawSchema(
    `Add, delete, and finalise the Condition options used during charting. Because conditions directly impact how patient data is recorded, it's important to have these reviewed and approved before your go-live date. If you are migrating from an existing PMS, your patients' historical conditions will be mapped to the options you configure here.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/charting/conditions`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: `Please review and approve at least ${reviewCount} conditions before completing this step`,
        };
      })
    );
  },
  pageVisitTracking,
};
